import { api } from './api';
import { SharedStep, SharedStepCreate, SharedStepUpdate } from '../types/sharedStep';

export const sharedStepService = {
    getSharedSteps: async (projectId: number, folderId?: number): Promise<SharedStep[]> => {
        const params = folderId ? { folder_id: folderId } : {};
        const response = await api.get(`/shared-steps`, { params: { project_id: projectId, ...params } });
        return response.data;
    },

    getInheritedSteps: async (projectId: number, folderId: number): Promise<SharedStep[]> => {
        const response = await api.get(`/shared-steps/inherited/${folderId}`, { params: { project_id: projectId } });
        return response.data;
    },

    createSharedStep: async (data: SharedStepCreate): Promise<SharedStep> => {
        const response = await api.post(`/shared-steps`, data);
        return response.data;
    },

    updateSharedStep: async (projectId: number, id: number, data: SharedStepUpdate): Promise<SharedStep> => {
        const response = await api.put(`/shared-steps/${id}`, { ...data, project_id: projectId });
        return response.data;
    },

    deleteSharedStep: async (projectId: number, id: number): Promise<void> => {
        await api.delete(`/shared-steps/${id}`, { params: { project_id: projectId } });
    }
}; 